// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// See LICENSE.md for licensing terms.
const internalSampleProvenance = new Set([
    'is_sample',
    '_sample',
    '_sample_package',
    '_sample_package_version',
    '_sample_package_module',
    '_sample_provenance_operation_id',
    '_sample_provenance_repair_required',
]);
/** Additional semantic visibility for human report facts, after each caller's security projection. */
export function shouldRenderEvidenceReportFact(key, row) {
    if (internalSampleProvenance.has(key))
        return false;
    // The canonical quality flag checks the support for an existing approved
    // claim. Its neutral 'complete' default says nothing about other statuses.
    return key !== 'approval_quality' || row.status === 'approved';
}
//# sourceMappingURL=evidence-report-human-facts.js.map